/// <reference path="../libs.ts" />
import { DialogType } from '@tableau/widgets';
import * as React from 'react';
import { AddLocalUsersDialog } from '../../app/users/AddLocalUsersDialog';
import { CommonStyles } from '../../common/react/CommonStyles';
import { AddLocalUserDialogCtrl } from '../controllers/AddLocalUserDialogCtrl';
import { SiteRolesEvent } from '../controllers/SiteMembershipDialogCtrl';
import { AngularContextFactory } from '../factories/AngularContextFactory';
import { FeatureFlags } from '../FeatureFlags';
import { Module } from '../Module';
import { SiteUsers } from '../resources/SiteUsers';
import { UserAddedEvent } from './AddUsersOptionsAction';
import { ModalService, ModalSize } from './ModalService';
import { ModalInstance, ReactModalService } from './ReactModalService';

const serverAndSiteUsersDialogStyle: React.CSSProperties = {
  width: 'auto',
  height: 'auto',
  paddingTop: CommonStyles.Sizes.LargeSpace,
  paddingBottom: CommonStyles.Sizes.MediumSpace,
  paddingLeft: CommonStyles.Sizes.MediumSpace,
  paddingRight: CommonStyles.Sizes.MediumSpace
};

export const AddLocalUserDialogType = {
  server: 'server',
  site: 'site'
};

export class AddLocalUserAction {

  public static $inject = [
    'AngularContextFactory',
    'ModalService',
    'SiteUsers'
  ];

  constructor(
    private angularContextFactory: AngularContextFactory,
    private modal: ModalService,
    private siteUsers: SiteUsers,
  ) { }

  public showAddLocalUserDialogForSite(
    dialogScope: ng.IScope,
    availableQuota: number): ng.IPromise<any> {

    if (FeatureFlags.addLocalUsersDialogReactEnabled) {
        let modalInstance: ModalInstance;
        const dialogProps = {
          dismiss: () => modalInstance && modalInstance.dismiss(),
          close: (result: any) => modalInstance && modalInstance.close(result),
          angularContext: this.angularContextFactory.create(dialogScope),
          addLocalUserDialogType: AddLocalUserDialogType.site,
          availableQuota: availableQuota,
          emitSiteRolesChanged: () => dialogScope.$emit(SiteRolesEvent.SiteRolesChanged),
          emitUserAddedEvent: () => dialogScope.$emit(UserAddedEvent)
        };

        modalInstance = ReactModalService.open({
          type: DialogType.Uber,
          dialogContent: React.createElement(AddLocalUsersDialog, dialogProps),
          testId: 'localSiteAddUsersDialog',
          showCloseButton: true,
          dialogStyle: serverAndSiteUsersDialogStyle,
          shouldNotSetDefaultWidth: true
        });

        return modalInstance.result;
      }

    const dialogInstance = this.modal.open({
      scope: dialogScope, // needed so that scope events can go through
      templateUrl: 'addLocalUserDialog.html',
      size: ModalSize.fitToContent,
      controller: AddLocalUserDialogCtrl,
      resolve: {
        mode: () => 'site',
        availableQuota: () => this.siteUsers.getRemainingUserQuota(),
      },
    });

    return dialogInstance.result;
  }

  public showAddLocalUserDialogForServer(
    dialogScope: ng.IScope): ng.IPromise<any> {

    if (FeatureFlags.addLocalUsersDialogReactEnabled) {
      let modalInstance: ModalInstance;
      const dialogProps = {
        dismiss: () => modalInstance && modalInstance.dismiss(),
        close: (result: any) => modalInstance && modalInstance.close(result),
        angularContext: this.angularContextFactory.create(dialogScope),
        addLocalUserDialogType: AddLocalUserDialogType.server,
        emitSiteRolesChanged: () => dialogScope.$emit(SiteRolesEvent.SiteRolesChanged),
        emitUserAddedEvent: () => dialogScope.$emit(UserAddedEvent)
      };

      modalInstance = ReactModalService.open({
        type: DialogType.Uber,
        dialogContent: React.createElement(AddLocalUsersDialog, dialogProps),
        testId: 'localServerAddUsersDialog',
        showCloseButton: true,
        dialogStyle: serverAndSiteUsersDialogStyle,
        shouldNotSetDefaultWidth: true
      });

      return modalInstance.result;
    }

    const dialogInstance = this.modal.open({
      scope: dialogScope, // needed so that scope events can go through
      templateUrl: 'addLocalUserDialog.html',
      size: ModalSize.fitToContent,
      controller: AddLocalUserDialogCtrl,
      resolve: {
        mode: () => 'server',
        availableQuota: () => <any>undefined, // no quota on server
      },
    });

    return dialogInstance.result;
  }

}

Module.instance().service('AddLocalUserAction', AddLocalUserAction);
